import React from 'react'
import {
  List,
  // Select,
  useTable,
  Table,
  TextField,
  Space,
  EditButton,
  Button,
  Popconfirm,
  Icons,
} from '@pankod/refine-antd'
import Head from 'next/head'
import {
  IResourceComponentsProps,
  GetListResponse,
  CrudFilters,
  useGetIdentity,
} from '@pankod/refine-core'

import { TCommonError } from 'src/interfaces/common'
import Filter, { TFilterForm } from '@components/ContentFilter'
import { ModalLMSAdmin } from './blocks/ModalLMSAdmin'
import { canManageAdminRole, ROLE_OPTIONS } from './role-acl'

import type { TLMSAdmin, TLMSModalType, TLMSAdminRole } from './types'

export const LMSAdminManagementList: React.FC<
  IResourceComponentsProps<GetListResponse<any>>
> = ({ options }) => {
  const { tableProps, searchFormProps } = useTable<
    TLMSAdmin,
    TCommonError,
    TFilterForm<TLMSAdmin>
  >({
    resource: 'admins',
    dataProviderName: 'lms',
    queryOptions: {
      initialData: {
        data: [],
        total: 0,
      },
    },
    onSearch: (params) => {
      const filters: CrudFilters = []
      const { email } = params
      filters.push(
        {
          field: 'email',
          operator: 'eq',
          value: email,
        },
        // disable for now
        // {
        //   field: 'role',
        //   operator: 'eq',
        //   value: role,
        // },
        {
          field: 't',
          operator: 'eq',
          value: new Date().getTime(),
        },
      )
      return filters
    },
    syncWithLocation: true,
  })

  const { data } = useGetIdentity<{ user: { LMSRole: TLMSAdminRole } }>()
  const LMSRole = data?.user?.LMSRole || ''

  const getActionACL = ({
    action,
    targetRole,
  }: {
    action: 'update' | 'delete'
    targetRole: TLMSAdminRole
  }) => canManageAdminRole({ actorRole: LMSRole, action, targetRole })

  const [showModal, setShowModal] = React.useState<TLMSModalType>(null)
  const [modalFormInstance, setModalFormInstance] = React.useState<any>(null)

  return (
    <List
      title="LMS Admin Management"
      createButtonProps={{
        children: 'Assign New Admin',
        onClick: () => {
          setShowModal('create')
        },
      }}
    >
      <Head>
        <title>LMS Admin | {options?.label}</title>
      </Head>

      <ModalLMSAdmin
        showModal={showModal}
        setShowModal={setShowModal}
        roleOptions={ROLE_OPTIONS}
        onModalInit={setModalFormInstance}
      />

      <Filter
        formProps={searchFormProps}
        items={[
          {
            label: 'User Email',
            name: 'email',
            placeholder: 'Search by user email',
          },
          // {
          //   label: 'Role',
          //   name: 'role',
          //   component: <Select options={ROLE_OPTIONS} allowClear />,
          // },
        ]}
      />

      <Table {...tableProps} rowKey="email">
        <Table.Column
          dataIndex="email"
          title="User Email"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="role"
          title="Role"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          title="Actions"
          render={(_, record: any) => (
            <Space>
              {getActionACL({
                action: 'update',
                targetRole: record.role,
              }) && (
                <EditButton
                  size="small"
                  onClick={() => {
                    modalFormInstance.setFieldsValue({
                      email: record.email,
                      role: record.role,
                    })
                    setShowModal('update')
                  }}
                  disabled={
                    !getActionACL({
                      action: 'update',
                      targetRole: record.role,
                    })
                  }
                />
              )}
              <Popconfirm
                title="Are you sure want to delete this user?"
                onConfirm={() => {
                  modalFormInstance.setFieldsValue({
                    email: record.email,
                    role: record.role,
                  })
                  setShowModal('delete')
                }}
                okButtonProps={{
                  danger: true,
                  type: 'default',
                }}
                okText="Delete"
                disabled={
                  !getActionACL({
                    action: 'delete',
                    targetRole: record.role,
                  })
                }
              >
                <Button
                  size="small"
                  danger
                  icon={<Icons.DeleteOutlined />}
                  disabled={
                    !getActionACL({
                      action: 'delete',
                      targetRole: record.role,
                    })
                  }
                >
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          )}
        />
      </Table>
    </List>
  )
}
